module.exports = __webpack_public_path__ + "img/c01_unitfireship_Normal_ua.06b402e4.webp";